export default {
  API_URL: '/gateway',
  COS: {
    bucket: 'ai-coach-test-1256119856',
    region: 'ap-shanghai',
    publicCOSBaseUrl: 'ai-coach-test-1256119856.cos.ap-shanghai.myqcloud.com/public/'
  },
  PRODUCT_CODE: 'AI_COACH',
  H5PreviewHost: 'https://test.project.hrtps.com/ai-coach-webview/operate/',
  H5: 'https://coach-h5-test.hrtps.com/', //  小程序 h5 版
  Matrix_Admin: 'https://matrix-admin-test.hrtps.com'
};
